<template>
    <div class="upload_box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="COS 图片上传" name="first">
                <!-- #region COS 图片上传 -->
                <el-card>
                    <div class="upload_block">
                        <el-radio-group v-model="imgCropper">
                            <el-radio-button :label="false">不裁切</el-radio-button>
                            <el-radio-button :label="true">裁切</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div class="upload_block">
                        <el-select v-model="cosConfig.Prefix" filterable placeholder="请选择">
                            <el-option v-for="item in Prefix" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="upload_block upload_images">
                        <upload-images-cos ref="UploadImages" :Prefix="cosConfig.Prefix" @returnImgs="getImgs" :needReturn="true" :imgCropper="imgCropper" :flexCol="`flexCol`">
                        </upload-images-cos>
                    </div>
                    <!-- <div>
                        <div @click="getBucket">查看</div>
                        <div @click="delBucket">删除</div>
                    </div> -->
                </el-card>
                <!-- #endregion -->
            </el-tab-pane>

            <el-tab-pane label="识别二维码" name="second">
                <!-- #region 上传二维码 -->
                <el-divider content-position="left">图片二维码</el-divider>
                <el-card>
                    <input type="file" @change="decodeQR">
                    <div>扫描结果:
                        <p v-if="qrResult">{{ qrResult }}</p>
                    </div>
                </el-card>
                <!-- #endregion -->
                <!-- #region 摄像头 -->
                <el-divider content-position="left">摄像头识别二维码</el-divider>
                <el-card>
                    <el-button type="primary" @click="openVideo" v-if="openVidStats == 0">开启摄像头</el-button>
                    <el-button type="primary" @click="closeVideo" v-else>关闭摄像头</el-button>
                    <div id="loadingMessage"></div>
                    <canvas id="canvas" v-show="openVidStats == 1"></canvas>
                    <div id="output" v-show="openVidStats == 1">
                        <div id="outputMessage">未检测到二维码</div>
                        <div hidden><b>Data:</b> <span id="outputData"></span></div>
                    </div>
                    <div>
                        已扫描列表：{{ codeList }}
                    </div>
                </el-card>
                <!-- #endregion -->
            </el-tab-pane>
        </el-tabs>

    </div>
</template>
<script>
//引用qrcode
import JSQR from 'jsqr'
import UploadImagesCos from '@/components/upload-images-cos'
var COS = require('cos-js-sdk-v5');
var cos = "", cosData = "";
var localStream = Object,
    video = Object;
export default {
    data: function () {
        return {
            activeName: 'first',
            cosConfig: {
                ImagesUrl: "https://images.cardhobby.com/",
                Bucket: "cardhobby-1255531135" /* 必须 */,
                Region: "ap-shanghai" /* 存储桶所在地域，必须字段 */,
                Key: "exampleobject" /* 必须 */,
                Prefix: "", //CardHobby/ /*文件目录*/
                SecretId: "",
            },//this.$store.state.cosConfig,
            imgCropper: false,
            Prefix: [{
                value: '',
                label: '根目录'
            }, {
                value: 'cardhobby/',
                label: '卡淘cardhobby'
            }, {
                value: 'ASCC/',
                label: 'ASCC'
            }, {
                value: 'TCG/',
                label: 'TCG'
            }, {
                value: 'DAKA/',
                label: '达咖DAKA'
            }, {
                value: 'raffle/',
                label: '抽奖raffle'
            },],
            list: [],
            qrResult: null,
            openVidStats: 0,
            codeList: []
        };
    },
    components: { UploadImagesCos },
    created: function () {
        var that = this;
        that.NewCos();

    },
    mounted: function () {
        var that = this;
    },
    beforeDestroy() {
    },
    watch: {

    },
    computed: {

    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
        //qrcode 读取二维码
        decodeQR(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const data = e.target.result;
                    const cvs = document.createElement('canvas');
                    const img = new Image();
                    img.onload = () => {
                        cvs.width = img.width;
                        cvs.height = img.height;
                        const ctx = cvs.getContext('2d');
                        ctx.drawImage(img, 0, 0);
                        const imageData = ctx.getImageData(0, 0, cvs.width, cvs.height);
                        const code = JSQR(imageData.data, cvs.width, cvs.height);
                        if (code) {
                            this.qrResult = code.data;
                        } else {
                            this.qrResult = 'No QR Code found.';
                        }
                    };
                    img.src = data;
                };
                reader.readAsDataURL(file);
            }
        },
        //摄像头识别二维码
        openVideo() {
            var that = this;
            that.openVidStats = 1;

            // var video = document.createElement("video");
            video = document.createElement("video");
            // Use facingMode: environment to attemt to get the front camera on phones
            navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } }).then(function (stream) {
                localStream = stream
                video.srcObject = localStream;
                video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
                video.play();
                requestAnimationFrame(tick);
            });

            var tick = function () {
                var canvasElement = document.getElementById("canvas");
                var canvas = canvasElement.getContext("2d");

                var drawLine = function (begin, end, color) {
                    canvas.beginPath();
                    canvas.moveTo(begin.x, begin.y);
                    canvas.lineTo(end.x, end.y);
                    canvas.lineWidth = 4;
                    canvas.strokeStyle = color;
                    canvas.stroke();
                }
                var loadingMessage = document.getElementById("loadingMessage");
                var outputContainer = document.getElementById("output");
                var outputMessage = document.getElementById("outputMessage");
                var outputData = document.getElementById("outputData");
                loadingMessage.innerText = "⌛ Loading video..."
                if (video.readyState === video.HAVE_ENOUGH_DATA) {
                    loadingMessage.hidden = true;
                    canvasElement.hidden = false;
                    outputContainer.hidden = false;

                    canvasElement.height = video.videoHeight;
                    canvasElement.width = video.videoWidth;
                    canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
                    var imageData = canvas.getImageData(0, 0, canvasElement.width, canvasElement.height);
                    var code = JSQR(imageData.data, imageData.width, imageData.height, {
                        inversionAttempts: "dontInvert",
                    });
                    if (code) {
                        drawLine(code.location.topLeftCorner, code.location.topRightCorner, "#FF3B58");
                        drawLine(code.location.topRightCorner, code.location.bottomRightCorner, "#FF3B58");
                        drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, "#FF3B58");
                        drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, "#FF3B58");
                        outputMessage.hidden = true;
                        outputData.parentElement.hidden = false;
                        outputData.innerText = code.data;
                        if (code.data && that.codeList.indexOf(code.data) <= -1) {
                            that.codeList.push(code.data);
                        }
                    } else {
                        outputMessage.hidden = false;
                        outputData.parentElement.hidden = true;
                    }
                }
                requestAnimationFrame(tick);//cancelAnimationFrame(tick);
            }
        },
        closeVideo() {
            this.openVidStats = 0;
            localStream.getVideoTracks()[0].stop();
            localStream.src = '';
            video.pause();
            // cancelAnimationFrame(this.tick());
        },
        getImgs(vals) {
            //编辑图片后返回赋值给formdata
            let that = this;
            if (vals && vals.length) {
                that.list = vals
            }
            console.log("that.FormData", that.list);
        },
        NewCos() {
            var that = this;
            //console.log(new Date(new Date().getTime() + 1.5 * 60 * 60 * 1000));
            cos = new COS({
                getAuthorization: function (options, callback) {
                    console.log('options:', options)
                    // 异步获取临时密钥
                    if (that.$cookie.get("cosData")) {
                        cosData = JSON.parse(that.$cookie.get("cosData"));
                        //console.log("$cookie.get.costoken", cosData);
                        var credentials = cosData.Credentials;
                        var cb = {
                            TmpSecretId: credentials.TmpSecretId,
                            TmpSecretKey: credentials.TmpSecretKey,
                            SecurityToken: credentials.Token,
                            // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                            StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
                            ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
                        }
                        //console.log("callback",cb);
                        callback(cb);
                    } else {
                        //var url = 'http://world.cardhobby.cn/upload/gettoken';
                        that.$get('costoken', "none")
                            .then(res => {
                                //console.log("costoken", res);
                                try {
                                    cosData = res;
                                    that.$cookie.set("cosData", JSON.stringify(res), { expires: new Date(new Date().getTime() + 1.5 * 60 * 60 * 1000) });
                                    //console.log("getAuthorization2 - data", cosData);
                                    var credentials = cosData.Credentials;
                                } catch (e) {
                                }
                                if (!cosData || !credentials) {
                                    return console.error('credentials invalid:\n' + cosData)
                                };
                                var cb = {
                                    TmpSecretId: credentials.TmpSecretId,
                                    TmpSecretKey: credentials.TmpSecretKey,
                                    SecurityToken: credentials.Token,
                                    // 建议返回服务器时间作为签名的开始时间，避免用户浏览器本地时间偏差过大导致签名错误
                                    StartTime: parseInt(cosData.StartTime), // 时间戳，单位秒，开始时间，即获取时刻的时间戳
                                    ExpiredTime: parseInt(cosData.ExpiredTime) // 时间戳，单位秒，超时时刻的时间戳
                                }
                                callback(cb);
                            })
                            .catch((err) => {
                                console.log(err);
                            });
                    }
                }
            });
        },
        getBucket() {
            let that = this;
            var cosConfig = that.cosConfig;
            console.log('cosConfig:', cosConfig);
            cos.getBucket({
                Bucket: cosConfig.Bucket, // 填入您自己的存储桶，必须字段
                Region: cosConfig.Region,  // 存储桶所在地域，例如ap-beijing，必须字段
                Prefix: that.Prefix,           // Prefix表示列出的object的key以prefix开始，非必须
            }, function (err, data) {
                console.log('err', err);
                console.log('data', data);
            });
        },
        delBucket() {
            let that = this;
            var cosConfig = that.cosConfig;
            cos.getBucket({
                Bucket: cosConfig.Bucket, // 填入您自己的存储桶，必须字段
                Region: cosConfig.Region,  // 存储桶所在地域，例如ap-beijing，必须字段
                Key: 'ASCC/2220c206128a95922c6beb5b48cdd094.jpg',// 存储在桶里的对象键，必须字段
            }, function (err, data) {
                console.log('err', err);
                console.log('data', data);
            });
        }
    }
};
</script>
<style scoped>
.upload_box {
    padding: 20px;
}

.upload_block {
    padding: 0 0 20px;
}

.upload_images {
    /* background: #f7f7f7; */
    display: flex;

}
</style>


// WEBPACK FOOTER //
// src/pages/upload/index.vue